"use client";

import { useRouter } from "next/navigation";
import { resetAuthCookies } from "../lib/actions";
import { useAuthStore } from "@/app/hooks/auth";
import MenuLink from "./navbar/MenuLink";

const LogoutButton = () => {
  const router = useRouter();
  const logout = useAuthStore((s) => s.logout);  // ⭐ Zustand logout

  const submitLogout = async () => {
    // Backend logout (cookies)
    await resetAuthCookies();

    // Frontend logout (Zustand)
    logout();  // ⭐ LIMPA O auth-storage

    // Redireciona
    // router.push("/landing");
    router.refresh();
  };

  return (
    <MenuLink
      label="👋 Sair"
      onClick={submitLogout}
    />
  );
};

export default LogoutButton;
